module.exports = __webpack_public_path__ + "static/media/photo82.3dabc937.jpg";